export const translations = {
  en: {
    "brand.tagline": "The #1 Real Supplement Evidence App",
    "brand.subtitle": "for your wellbeing and physical performance",
    "nav.scan": "Scan",
    "nav.library": "Library",
    "nav.evidence": "Evidence by condition",
    "ix.avoid": "Avoid",
    "ix.caution": "Caution",
    "ix.none": "no known interaction with your medications",
    "ix.addMeds": "Add your medications in My Stack to check interactions",
    "ix.myMeds": "My medications (to check interactions)",
    "ix.check": "Check",
    "ix.saved": "Medications saved and interactions checked",
    "share.title": "Share",
    "share.copy": "Copy link",
    "share.copied": "Link copied",
    "share.msg": "Look which nutrients and herbs PubMed studies explored for",
    "stack.addBtn": "My Stack",
    "stack.inStack": "In My Stack",
    "stack.addedFromCond": "Added to My Stack with the studied dose",
    "ev.title": "Evidence by health condition",
    "ev.tabSearch": "Search PubMed",
    "ev.searchGuest": "Create a free account to search PubMed for any supplement, herb or nutrient.",
    "cpub.h1": "Nutrients, herbs & natural products studied for",
    "cpub.studies": "PubMed clinical trials & meta-analyses analyzed",
    "cpub.more": "more compounds studied",
    "cpub.moreSub": "Unlock every compound with doses, duration, findings and sources.",
    "cpub.unlock": "Unlock with Premium",
    "cpub.metaTitle": "Evidence-based supplements & herbs for",
    "cpub.metaDesc": "Doses studied in PubMed clinical trials and meta-analyses for",
    "nav.formula": "Superathlete",
    "nav.pricing": "Premium",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "nav.dashboard": "Dashboard",
    "nav.myStack": "My Stack",
    "nav.community": "Community",
    "nav.profile": "Profile",
    "profile.title": "My Profile",
    "profile.sub": "Manage your account, language and password.",
    "profile.account": "Account",
    "profile.name": "Full name",
    "profile.language": "Language",
    "profile.save": "Save changes",
    "profile.saved": "Profile updated",
    "profile.changePw": "Change password",
    "profile.currentPw": "Current password",
    "profile.newPw": "New password",
    "profile.pwChanged": "Password updated",
    "community.title": "Members Community",
    "community.sub": "Share what works for you and discover what helps other members.",
    "community.search": "Search",
    "community.searchPlaceholder": "Search by keyword (e.g. energy, sleep, recovery)",
    "community.shareTitle": "Share your experience",
    "community.supplementPh": "Supplement (e.g. Creatine)",
    "community.helpsPh": "What it helps with (e.g. endurance)",
    "community.bodyPh": "Tell the community how it helped you (optional)…",
    "community.post": "Post",
    "community.posted": "Shared with the community",
    "community.empty": "No posts yet. Be the first to share what helps you!",
    "community.noResults": "No posts match your search.",
    "community.for": "for",
    "community.by": "by",
    "community.disclaimer": "Member experiences are personal opinions, not medical advice. Always consult a professional.",
    "community.modDelete": "Delete this post (moderation)",
    "landing.scanCta": "Scan a supplement",
    "landing.loginCta": "I already have an account",
    "landing.sources": "Sources: supplement experts and PubMed",
    "landing.featuresTitle": "Evidence, not marketing",
    "landing.f1.title": "Label Scanner",
    "landing.f1.desc": "Upload a supplement label and get instant AI ingredient analysis with evidence grades.",
    "landing.f2.title": "Live PubMed",
    "landing.f2.desc": "Real PubMed literature searches summarized by AI, neutral and educational.",
    "landing.f3.title": "Anti-Doping Safe",
    "landing.f3.desc": "Every ingredient flagged for WADA anti-doping status and safety notes.",
    "landing.f4.title": "Superathlete Formula",
    "landing.f4.desc": "Premium stack optimizer that finds overlaps, gaps and ideal timing.",
    "landing.ctaBottom": "Start scanning free",
    "disclaimer": "SUPPEV is an educational platform providing scientific evidence summaries. It does not diagnose, treat, prevent, or cure any disease. Consult a healthcare professional before supplement use.",
    "auth.loginTitle": "Welcome back",
    "auth.loginSub": "Log in to your Suppev account",
    "auth.registerTitle": "Create your account",
    "auth.registerSub": "Join and start scanning with real evidence",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login": "Log in",
    "auth.register": "Create account",
    "auth.forgot": "Forgot your password?",
    "auth.noAccount": "Don't have an account?",
    "auth.haveAccount": "Already have an account?",
    "auth.signup": "Sign up",
    "auth.signin": "Log in",
    "auth.forgotTitle": "Reset your password",
    "auth.forgotSub": "Enter your email and we'll send a reset link",
    "auth.sendReset": "Send reset link",
    "auth.resetTitle": "Set a new password",
    "auth.newPassword": "New password",
    "auth.updatePassword": "Update password",
    "auth.backToLogin": "Back to log in",
    "plan.free": "Free",
    "plan.premium": "Premium",
    "plan.comparisonTitle": "Free vs Premium",
    "plan.feat.scanner": "Supplement label scanner",
    "plan.feat.library": "Ingredient library & anti-doping",
    "plan.feat.pubmedBasic": "Basic PubMed evidence search",
    "plan.feat.pubmedStudies": "PubMed evidence & studies",
    "plan.feat.expertDose": "Expert dosing / research",
    "plan.feat.condition": "Evidence by health condition",
    "plan.feat.formula": "Superathlete Formula",
    "plan.membersOnly": "Members only",
    "scan.title": "Supplement Label Scanner",
    "scan.sub": "Upload a photo of a supplement facts label. Our AI extracts the ingredients and grades the evidence.",
    "scan.drop": "Drag & drop a label photo, or click to upload",
    "scan.samples": "Or try a sample label",
    "scan.camera": "Use camera",
    "scan.capture": "Capture photo",
    "scan.closeCamera": "Close camera",
    "scan.cameraError": "Could not access the camera. Check permissions.",
    "scan.start": "Analyze label",
    "scan.scanning": "Analyzing ingredients…",
    "scan.results": "Analysis results",
    "scan.overall": "Overall evidence score",
    "scan.ingredients": "Ingredients",
    "scan.active": "Active",
    "scan.filler": "Filler",
    "scan.safety": "Safety flags",
    "scan.again": "Scan another",
    "scan.error": "Could not analyze this image. Try a clearer supplement label photo.",
    "scan.aiNote": "Evidence grades and anti-doping status are AI-generated for education only — not medical or regulatory advice. Verify each product with your anti-doping authority.",
    "scan.goalLabel": "Your goal",
    "scan.medsLabel": "Medications / conditions (optional)",
    "scan.medsPlaceholder": "e.g. blood thinners, blood-pressure meds, diabetes",
    "scan.cleanLabelTitle": "Clean label check",
    "scan.fillers": "Fillers",
    "scan.preservatives": "Artificial preservatives",
    "scan.additives": "Artificial additives",
    "scan.clean": "Clean",
    "scan.detected": "Detected",
    "scan.organTitle": "Organ load (accumulation)",
    "scan.kidney": "Kidney",
    "scan.liver": "Liver",
    "scan.low": "Low",
    "scan.moderate": "Moderate",
    "scan.high": "High",
    "scan.interactionsTitle": "Most dangerous interactions",
    "scan.noInteractions": "No dangerous interactions identified for the information provided.",
    "scan.organLegend": "Low / Moderate / High = how much processing burden this product places on that organ at the label dose.",
    "scan.goalFitTitle": "Goal fit",
    "scan.safetyNote": "Safety is never guaranteed. This analysis is based on health research that is reviewed periodically and can change. Always tell your doctor before taking any supplement or combining it with medication, especially if you have a medical condition.",
    "scan.saveToStack": "Save to my stack",
    "scan.savedToStack": "Saved",
    "scan.freeScans": "free scans left this month",
    "scan.limitReached": "You've used all your free scans this month.",
    "scan.upgradeUnlimited": "Upgrade for up to 100 scans/month",
    "scan.unlimited": "Up to 100 scans/month",
    "scan.scansLeftFair": "scans left this month",
    "scan.fairUseReached": "You've reached this month's fair-use limit. It resets next month.",
    "scan.complete": "Analysis complete",
    "scan.guestUsed": "You used 1 free scan. Create a free account to keep your result and get the rest of your free scans this month.",
    "scan.guestCreate": "Create free account",
    "scan.guestNotNow": "Not now",
    "scan.guestFree": "Free",
    "scan.guestFreeDesc": "Limited scans per month and basic result.",
    "scan.guestPaid": "Paid",
    "scan.guestPaidDesc": "Up to 100 scans/month, full PubMed evidence, evidence by health condition, and Superathlete Formula.",
    "scan.guestSeePlans": "See plans",
    "nav.stack": "My Stack",
    "stack.title": "My Stack",
    "stack.sub": "Save the supplements you take and check the combined load on your organs and any interactions.",
    "stack.empty": "Your stack is empty. Scan a supplement and tap \"Save to my stack\".",
    "stack.goScan": "Scan a supplement",
    "stack.remove": "Remove",
    "stack.analyze": "Analyze combined load",
    "stack.analyzing": "Analyzing your stack…",
    "stack.combinedKidney": "Combined kidney load",
    "stack.combinedLiver": "Combined liver load",
    "stack.interactionsTitle": "Interactions in your stack",
    "stack.noInteractions": "No notable combined interactions identified.",
    "lib.title": "Ingredient Library",
    "lib.sub": "Evidence-graded ingredients with athletic goals and anti-doping notes.",
    "lib.search": "Search ingredients…",
    "lib.goal": "Goal",
    "lib.grade": "Evidence",
    "lib.all": "All",
    "lib.studies": "clinical studies",
    "lib.dosage": "Typical dosage",
    "lib.safety": "Safety",
    "lib.wada": "Anti-doping",
    "lib.viewPubmed": "View on PubMed",
    "lib.wadaNote": "Anti-doping (WADA) status is a curated educational reference, not an official ruling. Always confirm the specific product with your anti-doping authority.",
    "goal.strength": "Strength",
    "goal.endurance": "Endurance",
    "goal.energy": "Energy",
    "goal.recovery": "Recovery",
    "goal.weight_loss": "Weight loss",
    "goal.general_health": "General health",
    "goal.heart_health": "Heart health",
    "grade.A": "Grade A · Strong",
    "grade.B": "Grade B · Moderate",
    "grade.C": "Grade C · Inconclusive",
    "grade.D": "Grade D · Caution",
    "wada.safe": "WADA Safe",
    "wada.monitored": "WADA Monitored",
    "wada.caution": "Caution",
    "wada.prohibited": "Prohibited",
    "pubmed.title": "Live PubMed Evidence",
    "pubmed.sub": "Search real PubMed literature. AI summarizes it neutrally for education.",
    "pubmed.search": "Search a supplement, herb, nutrient or natural product…",
    "pubmed.go": "Search",
    "pubmed.searching": "Searching PubMed…",
    "pubmed.summary": "AI summary",
    "pubmed.studies": "Recent studies",
    "pubmed.conditionsTitle": "Evidence by health condition",
    "pubmed.conditionsSub": "Pick a condition and see which nutrients, herbs and natural products PubMed trials studied — with the doses used. Premium only.",
    "pubmed.stage": "Evidence stage",
    "pubmed.premiumLock": "Full evidence by health condition is a Premium feature.",
    "cond.customPh": "Or type any condition (e.g. psoriasis, gout)…",
    "cond.analyzing": "Reading PubMed clinical trials & meta-analyses… (≈15s)",
    "cond.compounds": "Nutrients, herbs & natural products studied",
    "cond.dose": "Doses studied",
    "cond.duration": "Duration",
    "cond.sources": "Sources",
    "cond.doseNote": "Doses are those reported in the studies, not recommendations. Talk to your doctor before taking anything.",
    "cond.none": "No compounds could be extracted for this condition.",
    "cond.cat.nutrient": "Nutrient", "cond.cat.herb": "Herb", "cond.cat.natural_product": "Natural product", "cond.cat.probiotic": "Probiotic",
    "cond.str.strong": "Strong evidence", "cond.str.moderate": "Moderate evidence", "cond.str.limited": "Limited evidence", "cond.str.mixed": "Mixed evidence",
    "pubmed.upgrade": "Upgrade to Premium",
    "formula.title": "Superathlete Formula",
    "formula.sub": "Optimize your supplement stack: overlaps, gaps and ideal timing.",
    "formula.add": "Add a supplement",
    "formula.analyze": "Optimize my stack",
    "formula.yourStack": "Your stack",
    "formula.empty": "Add supplements from the library to build your stack.",
    "formula.timing": "Recommended timing",
    "formula.overlaps": "Overlaps & redundancies",
    "formula.gaps": "Nutritional gaps",
    "formula.lock": "The Superathlete Formula is unlocked with the Annual plan.",
    "pricing.title": "Go Premium",
    "pricing.sub": "Unlock full PubMed evidence, evidence by health condition and the Superathlete Formula.",
    "pricing.weekly": "Weekly",
    "pricing.monthly": "Monthly",
    "pricing.perWeek": "/week",
    "pricing.perMonth": "/month",
    "pricing.save": "Save ~50%",
    "pricing.yearly": "Yearly",
    "pricing.perYear": "/year",
    "pricing.bestValue": "Best value",
    "stack.analyzeLock": "Combined stack analysis (organ load + interactions) is a Premium feature.",
    "pricing.subscribe": "Subscribe",
    "pricing.redirect": "Redirecting to secure checkout…",
    "pricing.current": "You're Premium",
    "pricing.manage": "Manage subscription",
    "pricing.manageSub": "Cancel or switch your weekly/monthly plan anytime.",
    "pricing.securedBy": "Secure recurring payment powered by Stripe",
    "success.title": "Welcome to Premium!",
    "success.sub": "Your subscription is active. All Premium features are unlocked.",
    "success.verifying": "Confirming your payment…",
    "success.explore": "Explore Premium",
    "cancel.title": "Checkout cancelled",
    "cancel.sub": "No charge was made. You can upgrade anytime.",
    "cancel.retry": "Back to pricing",
    "common.premium": "PREMIUM",
    "common.loading": "Loading…",
    "common.free": "FREE",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
  },
  es: {
    "brand.tagline": "La 1ª app con evidencia real de suplementos",
    "brand.subtitle": "para tu bienestar y rendimiento físico",
    "nav.scan": "Escanear",
    "nav.library": "Biblioteca",
    "nav.evidence": "Evidencia por condición",
    "ix.avoid": "Evitar",
    "ix.caution": "Precaución",
    "ix.none": "sin interacción conocida con tus medicamentos",
    "ix.addMeds": "Agrega tus medicamentos en Mi Stack para revisar interacciones",
    "ix.myMeds": "Mis medicamentos (para revisar interacciones)",
    "ix.check": "Revisar",
    "ix.saved": "Medicamentos guardados e interacciones revisadas",
    "share.title": "Compartir",
    "share.copy": "Copiar enlace",
    "share.copied": "Enlace copiado",
    "share.msg": "Mira qué nutrientes y hierbas estudió PubMed para",
    "stack.addBtn": "Mi Stack",
    "stack.inStack": "En Mi Stack",
    "stack.addedFromCond": "Agregado a Mi Stack con la dosis estudiada",
    "ev.title": "Evidencia por condición de salud",
    "ev.tabSearch": "Buscar en PubMed",
    "ev.searchGuest": "Crea una cuenta gratis para buscar en PubMed cualquier suplemento, hierba o nutriente.",
    "cpub.h1": "Nutrientes, hierbas y productos naturales estudiados para",
    "cpub.studies": "ensayos clínicos y metaanálisis de PubMed analizados",
    "cpub.more": "compuestos más estudiados",
    "cpub.moreSub": "Desbloquea todos los compuestos con dosis, duración, hallazgos y fuentes.",
    "cpub.unlock": "Desbloquear con Premium",
    "cpub.metaTitle": "Suplementos y hierbas con evidencia para",
    "cpub.metaDesc": "Dosis estudiadas en ensayos clínicos y metaanálisis de PubMed para",
    "nav.formula": "Superatleta",
    "nav.pricing": "Premium",
    "nav.login": "Iniciar sesión",
    "nav.register": "Registrarse",
    "nav.logout": "Cerrar sesión",
    "nav.dashboard": "Panel",
    "nav.myStack": "Mi Stack",
    "nav.community": "Comunidad",
    "nav.profile": "Perfil",
    "profile.title": "Mi Perfil",
    "profile.sub": "Administra tu cuenta, idioma y contraseña.",
    "profile.account": "Cuenta",
    "profile.name": "Nombre completo",
    "profile.language": "Idioma",
    "profile.save": "Guardar cambios",
    "profile.saved": "Perfil actualizado",
    "profile.changePw": "Cambiar contraseña",
    "profile.currentPw": "Contraseña actual",
    "profile.newPw": "Contraseña nueva",
    "profile.pwChanged": "Contraseña actualizada",
    "community.title": "Comunidad de Miembros",
    "community.sub": "Comparte lo que te funciona y descubre qué le ayuda a otros miembros.",
    "community.search": "Buscar",
    "community.searchPlaceholder": "Busca por palabra clave (ej: energía, sueño, recuperación)",
    "community.shareTitle": "Comparte tu experiencia",
    "community.supplementPh": "Suplemento (ej: Creatina)",
    "community.helpsPh": "Para qué te ayuda (ej: resistencia)",
    "community.bodyPh": "Cuéntale a la comunidad cómo te ayudó (opcional)…",
    "community.post": "Publicar",
    "community.posted": "Compartido con la comunidad",
    "community.empty": "Aún no hay publicaciones. ¡Sé el primero en compartir lo que te ayuda!",
    "community.noResults": "Ninguna publicación coincide con tu búsqueda.",
    "community.for": "para",
    "community.by": "por",
    "community.disclaimer": "Las experiencias de los miembros son opiniones personales, no consejo médico. Consulta siempre a un profesional.",
    "community.modDelete": "Eliminar esta publicación (moderación)",
    "landing.scanCta": "Escanear un suplemento",
    "landing.loginCta": "Ya tengo una cuenta",
    "landing.sources": "Fuentes: expertos en suplementos y PubMed",
    "landing.featuresTitle": "Evidencia, no marketing",
    "landing.f1.title": "Escáner de Etiquetas",
    "landing.f1.desc": "Sube una etiqueta y obtén análisis instantáneo de ingredientes con nivel de evidencia.",
    "landing.f2.title": "PubMed en Vivo",
    "landing.f2.desc": "Búsquedas reales en PubMed resumidas por IA, neutrales y educativas.",
    "landing.f3.title": "Seguro Antidopaje",
    "landing.f3.desc": "Cada ingrediente con su estado antidopaje WADA y notas de seguridad.",
    "landing.f4.title": "Fórmula del Superatleta",
    "landing.f4.desc": "Optimizador Premium que detecta solapamientos, carencias y horarios ideales.",
    "landing.ctaBottom": "Empieza a escanear gratis",
    "disclaimer": "SUPPEV es una plataforma educativa que ofrece resúmenes de evidencia científica. No diagnostica, trata, previene ni cura ninguna enfermedad. Consulta a un profesional de la salud antes de usar suplementos.",
    "auth.loginTitle": "Bienvenido de nuevo",
    "auth.loginSub": "Inicia sesión en tu cuenta de Suppev",
    "auth.registerTitle": "Crea tu cuenta",
    "auth.registerSub": "Únete y empieza a escanear con evidencia real",
    "auth.name": "Nombre completo",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.login": "Iniciar sesión",
    "auth.register": "Crear cuenta",
    "auth.forgot": "¿Olvidaste tu contraseña?",
    "auth.noAccount": "¿No tienes cuenta?",
    "auth.haveAccount": "¿Ya tienes cuenta?",
    "auth.signup": "Registrarse",
    "auth.signin": "Iniciar sesión",
    "auth.forgotTitle": "Recupera tu contraseña",
    "auth.forgotSub": "Ingresa tu correo y te enviaremos un enlace",
    "auth.sendReset": "Enviar enlace",
    "auth.resetTitle": "Establece una nueva contraseña",
    "auth.newPassword": "Nueva contraseña",
    "auth.updatePassword": "Actualizar contraseña",
    "auth.backToLogin": "Volver a iniciar sesión",
    "plan.free": "Gratis",
    "plan.premium": "Premium",
    "plan.comparisonTitle": "Gratis vs Premium",
    "plan.feat.scanner": "Escáner de etiquetas",
    "plan.feat.library": "Biblioteca de ingredientes y antidopaje",
    "plan.feat.pubmedBasic": "Búsqueda básica de evidencia PubMed",
    "plan.feat.pubmedStudies": "Evidencia y estudios en PubMed",
    "plan.feat.expertDose": "Dosis / investigación por experto",
    "plan.feat.condition": "Evidencia por condición de salud",
    "plan.feat.formula": "Fórmula del Superatleta",
    "plan.membersOnly": "Solo miembros",
    "scan.title": "Escáner de Etiquetas",
    "scan.sub": "Sube una foto de la etiqueta de un suplemento. Nuestra IA extrae los ingredientes y evalúa la evidencia.",
    "scan.drop": "Arrastra una foto de la etiqueta o haz clic para subir",
    "scan.samples": "O prueba una etiqueta de ejemplo",
    "scan.camera": "Usar cámara",
    "scan.capture": "Capturar foto",
    "scan.closeCamera": "Cerrar cámara",
    "scan.cameraError": "No se pudo acceder a la cámara. Revisa los permisos.",
    "scan.start": "Analizar etiqueta",
    "scan.scanning": "Analizando ingredientes…",
    "scan.results": "Resultados del análisis",
    "scan.overall": "Puntuación global de evidencia",
    "scan.ingredients": "Ingredientes",
    "scan.active": "Activo",
    "scan.filler": "Relleno",
    "scan.safety": "Alertas de seguridad",
    "scan.again": "Escanear otro",
    "scan.error": "No se pudo analizar la imagen. Prueba con una foto más clara de la etiqueta.",
    "scan.aiNote": "Los niveles de evidencia y el estado antidopaje son generados por IA solo con fines educativos — no son consejo médico ni regulatorio. Verifica cada producto con tu autoridad antidopaje.",
    "scan.goalLabel": "Tu objetivo",
    "scan.medsLabel": "Medicamentos / condiciones (opcional)",
    "scan.medsPlaceholder": "p. ej. anticoagulantes, medicación para la presión, diabetes",
    "scan.cleanLabelTitle": "Chequeo de etiqueta limpia",
    "scan.fillers": "Rellenos",
    "scan.preservatives": "Conservantes artificiales",
    "scan.additives": "Aditivos artificiales",
    "scan.clean": "Limpio",
    "scan.detected": "Detectado",
    "scan.organTitle": "Carga en órganos (acumulación)",
    "scan.kidney": "Riñón",
    "scan.liver": "Hígado",
    "scan.low": "Baja",
    "scan.moderate": "Moderada",
    "scan.high": "Alta",
    "scan.interactionsTitle": "Interacciones más peligrosas",
    "scan.noInteractions": "No se identificaron interacciones peligrosas con la información proporcionada.",
    "scan.organLegend": "Baja / Moderada / Alta = cuánta carga de procesamiento impone este producto a ese órgano en la dosis de la etiqueta.",
    "scan.goalFitTitle": "Ajuste al objetivo",
    "scan.safetyNote": "La seguridad nunca está garantizada. Este análisis se basa en investigación de salud que se revisa periódicamente y puede cambiar. Informa siempre a tu médico antes de tomar cualquier suplemento o combinarlo con algún medicamento, especialmente si tienes alguna enfermedad.",
    "scan.saveToStack": "Guardar en mi stack",
    "scan.savedToStack": "Guardado",
    "scan.freeScans": "escaneos gratis restantes este mes",
    "scan.limitReached": "Has usado todos tus escaneos gratis de este mes.",
    "scan.upgradeUnlimited": "Hazte Premium para hasta 100 escaneos al mes",
    "scan.unlimited": "Hasta 100 escaneos al mes",
    "scan.scansLeftFair": "escaneos restantes este mes",
    "scan.fairUseReached": "Has alcanzado el límite de uso justo de este mes. Se reinicia el próximo mes.",
    "scan.complete": "Análisis completo",
    "scan.guestUsed": "Usaste 1 escaneo gratis. Crea una cuenta gratis para guardar tu resultado y obtener el resto de tus escaneos gratis de este mes.",
    "scan.guestCreate": "Crear cuenta gratis",
    "scan.guestNotNow": "Ahora no",
    "scan.guestFree": "Gratis",
    "scan.guestFreeDesc": "Escaneos limitados al mes y resultado básico.",
    "scan.guestPaid": "De pago",
    "scan.guestPaidDesc": "Hasta 100 escaneos al mes, evidencia completa de PubMed, evidencia por condición de salud y la Fórmula del Superatleta.",
    "scan.guestSeePlans": "Ver planes",
    "nav.stack": "Mi Stack",
    "stack.title": "Mi Stack",
    "stack.sub": "Guarda los suplementos que tomas y revisa la carga combinada en tus órganos y las interacciones.",
    "stack.empty": "Tu stack está vacío. Escanea un suplemento y pulsa \"Guardar en mi stack\".",
    "stack.goScan": "Escanear un suplemento",
    "stack.remove": "Quitar",
    "stack.analyze": "Analizar carga combinada",
    "stack.analyzing": "Analizando tu stack…",
    "stack.combinedKidney": "Carga combinada en riñón",
    "stack.combinedLiver": "Carga combinada en hígado",
    "stack.interactionsTitle": "Interacciones en tu stack",
    "stack.noInteractions": "No se identificaron interacciones combinadas notables.",
    "lib.title": "Biblioteca de Ingredientes",
    "lib.sub": "Ingredientes con nivel de evidencia, objetivos atléticos y notas antidopaje.",
    "lib.search": "Buscar ingredientes…",
    "lib.goal": "Objetivo",
    "lib.grade": "Evidencia",
    "lib.all": "Todos",
    "lib.studies": "estudios clínicos",
    "lib.dosage": "Dosis típica",
    "lib.safety": "Seguridad",
    "lib.wada": "Antidopaje",
    "lib.viewPubmed": "Ver en PubMed",
    "lib.wadaNote": "El estado antidopaje (WADA) es una referencia educativa curada, no un dictamen oficial. Confirma siempre el producto concreto con tu autoridad antidopaje.",
    "goal.strength": "Fuerza",
    "goal.endurance": "Resistencia",
    "goal.energy": "Energía",
    "goal.recovery": "Recuperación",
    "goal.weight_loss": "Pérdida de peso",
    "goal.general_health": "Salud general",
    "goal.heart_health": "Salud cardiaca",
    "grade.A": "Nivel A · Fuerte",
    "grade.B": "Nivel B · Moderado",
    "grade.C": "Nivel C · No concluyente",
    "grade.D": "Nivel D · Precaución",
    "wada.safe": "WADA Seguro",
    "wada.monitored": "WADA Monitorizado",
    "wada.caution": "Precaución",
    "wada.prohibited": "Prohibido",
    "pubmed.title": "Evidencia PubMed en Vivo",
    "pubmed.sub": "Busca literatura real en PubMed. La IA la resume de forma neutral y educativa.",
    "pubmed.search": "Busca un suplemento, hierba, nutriente o producto natural…",
    "pubmed.go": "Buscar",
    "pubmed.searching": "Buscando en PubMed…",
    "pubmed.summary": "Resumen IA",
    "pubmed.studies": "Estudios recientes",
    "pubmed.conditionsTitle": "Evidencia por condición de salud",
    "pubmed.conditionsSub": "Elige una condición y ve qué nutrientes, hierbas y productos naturales se estudiaron en PubMed, con las dosis usadas. Solo Premium.",
    "pubmed.stage": "Etapa de evidencia",
    "pubmed.premiumLock": "La evidencia completa por condición de salud es una función Premium.",
    "cond.customPh": "O escribe cualquier condición (ej. psoriasis, gota)…",
    "cond.analyzing": "Leyendo ensayos clínicos y metaanálisis de PubMed… (≈15s)",
    "cond.compounds": "Nutrientes, hierbas y productos naturales estudiados",
    "cond.dose": "Dosis estudiadas",
    "cond.duration": "Duración",
    "cond.sources": "Fuentes",
    "cond.doseNote": "Las dosis son las reportadas en los estudios, no recomendaciones. Consulta a tu médico antes de tomar cualquier cosa.",
    "cond.none": "No se pudieron extraer compuestos para esta condición.",
    "cond.cat.nutrient": "Nutriente", "cond.cat.herb": "Hierba", "cond.cat.natural_product": "Producto natural", "cond.cat.probiotic": "Probiótico",
    "cond.str.strong": "Evidencia fuerte", "cond.str.moderate": "Evidencia moderada", "cond.str.limited": "Evidencia limitada", "cond.str.mixed": "Evidencia mixta",
    "pubmed.upgrade": "Hazte Premium",
    "formula.title": "Fórmula del Superatleta",
    "formula.sub": "Optimiza tu stack de suplementos: solapamientos, carencias y horarios ideales.",
    "formula.add": "Añadir suplemento",
    "formula.analyze": "Optimizar mi stack",
    "formula.yourStack": "Tu stack",
    "formula.empty": "Añade suplementos de la biblioteca para construir tu stack.",
    "formula.timing": "Horario recomendado",
    "formula.overlaps": "Solapamientos y redundancias",
    "formula.gaps": "Carencias nutricionales",
    "formula.lock": "La Fórmula del Superatleta se desbloquea con el plan Anual.",
    "pricing.title": "Hazte Premium",
    "pricing.sub": "Desbloquea la evidencia completa de PubMed, la evidencia por condición de salud y la Fórmula del Superatleta.",
    "pricing.weekly": "Semanal",
    "pricing.monthly": "Mensual",
    "pricing.perWeek": "/semana",
    "pricing.perMonth": "/mes",
    "pricing.save": "Ahorra ~50%",
    "pricing.yearly": "Anual",
    "pricing.perYear": "/año",
    "pricing.bestValue": "Mejor valor",
    "stack.analyzeLock": "El análisis combinado del stack (carga en órganos + interacciones) es una función Premium.",
    "pricing.subscribe": "Suscribirse",
    "pricing.redirect": "Redirigiendo al pago seguro…",
    "pricing.current": "Eres Premium",
    "pricing.manage": "Gestionar suscripción",
    "pricing.manageSub": "Cancela o cambia tu plan semanal/mensual cuando quieras.",
    "pricing.securedBy": "Pago recurrente seguro con Stripe",
    "success.title": "¡Bienvenido a Premium!",
    "success.sub": "Tu suscripción está activa. Todas las funciones Premium están desbloqueadas.",
    "success.verifying": "Confirmando tu pago…",
    "success.explore": "Explorar Premium",
    "cancel.title": "Pago cancelado",
    "cancel.sub": "No se realizó ningún cargo. Puedes suscribirte cuando quieras.",
    "cancel.retry": "Volver a precios",
    "common.premium": "PREMIUM",
    "common.loading": "Cargando…",
    "common.free": "GRATIS",
    "footer.privacy": "Política de Privacidad",
    "footer.terms": "Términos de Servicio",
  },
};
